import $ from 'jquery';
import setupBisAndSo from '../pdp/bis-and-so';
import logEngagement from '../../modules/log-engagement';
const ENGAGEMENT_MODULE = 'shopping_bag';
import { renderCartSocialProof } from 'modules/social-proof';

$(function(){
    bindEvents();

    showBagSyncNotifications();
    $(window).on('shoppingbag.wishlist.added.to.bag', function () {
        reloadShoppingBag(function () {
            $('body').css({'overflow-y': ''});
            $.modal({
                open: "wishlist-added-modal",
                triggerOpen: true
            });
        });
    });

    renderCartSocialProof($('.js-cart-item').toArray().map((el) => $(el).data('code')));
});


function reloadShoppingBag(callback, removedItemIndex){
    let param="";
    if(typeof removedItemIndex !== "undefined" && removedItemIndex !== -1){
        param = "?removedItemIndex=" + removedItemIndex;
    }
    $('#page-content').load("ShoppingBagContent.jsp"+ param, function () {
        if(typeof callback === 'function'){
            callback();
        }
        bindEvents();
        $('#page-content').find('.js-fixed-overlay').fixedOverlay();
        $('#page-content').find('.vanish').vanish();
        resetLazyLoad();
        updateBagCount();
        window.rcProps.shoppingBag = window.rcProps.shoppingBag || {};
        if (window.rcProps.shoppingBag.gotoPayPal === true) {
            if (typeof renderPayPal === 'function') {
                renderPayPal();
            }
        }
        $('.js-modal').modal();
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
        window.KlarnaOnsiteService.push({eventName: 'refresh-placements'});
    })
}
function bindWishlistEvents() {
    $('.js-wishlist-add-to-bag').click(function () {
        var btn = $(this);
        var size = btn.data('size');
        var code = btn.data('code');
        if(size == ''){
            var $sizeDiv = $('#wishListNoSize_' + code);
            loadSizeMenu(code, $sizeDiv, function(rtn) {
                $sizeDiv.html(rtn);
                //Remove the ability to scroll main content while overlay is present
                $('body').css({'overflow-y': 'hidden'});

                $sizeDiv.find(".js-add-to-bag-size-menu").click(function (e) {
                    var size = $(this).data('size');
                    var btn = $('#js-wishlist-add-to-bag-' + code);
                    var checkstock= $(this).find('.checkstock').data('stock');
                    if (!checkstock) {
                        addToBagFromWishList(code, size, btn);
                        $('body').css({'overflow-y': ''});
                    }
                });

                $sizeDiv.find('.showBis').click(function(e){
                    e.preventDefault();
                    var href = $(this).attr('href');
                    $.modal({
                        url : href,
                        type : 'full',
                        triggerOpen : true,
                        onComplete : setupBisAndSo
                    });
                });
            });
        }else{
            addToBagFromWishList(code, size, btn);
        }
    });
    $('.js-fixed-overlay').fixedOverlay();
}

window.bindWishlistEvents = bindWishlistEvents;

function bindItemListContainerEvents(container_class) {
    $('.' + container_class).click(function () {
        var btn = $(this);
        var size = btn.data('size');
        var code = btn.data('code');
        var module_name = btn.data('module');
        var action_name = btn.data('action');
        var modal_id = btn.data('success-notification-modal-id');
        if(size == ''){
            var $sizeDiv = $('#' + container_class + '-sizes-' + code);
            loadSizeMenu(code, $sizeDiv, function(rtn) {
                $sizeDiv.html(rtn);
                //Remove the ability to scroll main content while overlay is present
                $('body').css({'overflow-y': 'hidden'});

                $sizeDiv.find(".js-add-to-bag-size-menu").click(function (e) {
                    var size = $(this).data('size');
                    var btn = $('#' + container_class + '-' + code);
                    var checkstock= $(this).find('.checkstock').data('stock');
                    if (!checkstock) {
                        addToBagFromItemListContainer(code, size, btn, module_name, action_name, modal_id);
                        $('body').css({'overflow-y': ''});
                    }
                });

                $sizeDiv.find('.showBis').click(function(e){
                    e.preventDefault();
                    var href = $(this).attr('href');
                    $.modal({
                        url : href,
                        type : 'full',
                        triggerOpen : true,
                        onComplete : setupBisAndSo
                    });
                });
            });
        }else{
            addToBagFromItemListContainer(code, size, btn, module_name, action_name, modal_id);
        }
    });
    $('.js-fixed-overlay').fixedOverlay();
}

window.bindItemListContainerEvents = bindItemListContainerEvents;

function bindEvents(){
    $('.js-toggle-display').toggleDisplay();
    $('.js-remove-prod').click(function(e){
        e.preventDefault();
        var wrapper = $('#' + $(this).data('wrapper'));
        var code = wrapper.data('code');
        var size = wrapper.data('size');
        var serial = wrapper.data('serial');
        const removedItemIndex = $(this).data('wrapper').substring(5);
        var itemRemovedModal = document.getElementById("item-removed-modal"); // test id=931, group A
        removeFromBag(code, size, wrapper.data('qty'), function(){
            reloadShoppingBag(function(){
              if(itemRemovedModal) { // show notification if test id=931, group A
                $.modal({
                    open: "item-removed-modal",
                    triggerOpen: true
                });
              }
            }, removedItemIndex);
        }, serial, false, wrapper);
        logEngagement(
            window.location.href,
            ENGAGEMENT_MODULE,
            'remove_item',
            { code: code }
        );
    });

    $('.js-save-qty').click(function(){
        let element = $('#'+$(this).data('id'));
        updateQuantity(element);
    });

    $('.js-wishlist-prod').click(function(e){
        e.preventDefault();
        logEngagement( // Calling first since this might redirect to the login page
            window.location.href,
            ENGAGEMENT_MODULE,
            'move_wishlist',
            { code: code }
        );
        if (window.rcProps.shoppingBag.isGuest && !window.rcProps.shoppingBag.canGuestsHaveFavorites) {
            var redirectPage = '/fw/mobile/ShoppingBag.jsp' + location.search;
            window.location = '/fw/mobile/Login.jsp?returnURL=' + encodeURIComponent(redirectPage);
        } else {
            var wrapper = $('#' + $(this).data('wrapper'));
            var code = wrapper.data('code');
            var size = wrapper.data('size');
            const removedItemIndex = $(this).data('wrapper').substring(5);
            var data = $.param({
                code : code,
                sectionURL : window.rcProps.shoppingBag.sectionUrl,
                sessionID : window.rcProps.shoppingBag.sessionID,
                size : size,
                email : window.rcProps.shoppingBag.email,
                d : window.rcProps.department,
            });

            $.post("/fw/addToWishList.jsp", data, function(){
                if(typeof  window.insertCordialUpdateWishList === 'function'){
                    insertCordialUpdateWishList('add', code);
                }
                if(typeof window.insertPageTrackForMobile === 'function'){
                    insertPageTrackForMobile(false, code);
                }
                if(typeof window.gaUpdateWishList === 'function'){
                    gaUpdateWishList('add',code);
                }
                if(typeof window.taboolaWishListAction === 'function') {
                    window.taboolaWishListAction("add", code);
                }
                if(typeof brazeAddToFavorites === 'function') {
                    brazeAddToFavorites('add',
                        code,
                        wrapper.data('name'),
                        size,
                        wrapper.data('imageurl'),
                        wrapper.data('pdpurl'),
                        wrapper.data('price'),
                        wrapper.data('currency'),
                        wrapper.data('department'),
                        wrapper.data('color'),
                        wrapper.data('brand'),
                        wrapper.data('category'),
                        wrapper.data('cat1'));
                }
                removeFromBag(code, size, wrapper.data('qty'), function(){
                    reloadShoppingBag(function(){
                        $.modal({
                            open: "item-wishlist-modal",
                            triggerOpen: true
                        });
                    }, removedItemIndex);
                }, undefined,true, wrapper);
            });
        }
    });

    $('.js-undo-remove-item').on('click', function () {
        const btn = $(this);
        const movedToWishList = btn.data('movedtowishlist');
        if(movedToWishList) {
            $.ajax({
                type: 'POST',
                url: 'ajaxAddToWishlist.jsp?&cond=remove&code=' + btn.data('code') + '&size=' + btn.data('size'),
                success: function (response) {
                    addToBag(btn.data('code'), btn.data('size'), btn, null, btn.data('serial'));
                    logEngagement(
                        window.location.href,
                        ENGAGEMENT_MODULE,
                        'undo_remove',
                        {code: btn.data('code')}
                    );
                }
            });
        } else {
            addToBag(btn.data('code'), btn.data('size'), btn, null, btn.data('serial'));
            logEngagement(
                window.location.href,
                ENGAGEMENT_MODULE,
                'undo_remove',
                {code: btn.data('code')}
            );
        }
    });
}

function updateQuantity(element){
    const wrapper = $('#' + element.data('wrapper'));
    const code = wrapper.data('code');
    const size = wrapper.data('size');
    const oldQty = wrapper.data('qty');
    const newQty = element.val();
    if(parseInt(newQty) == 0){
        const removedItemIndex = element.data('wrapper').substring(5);
        removeFromBag(code, size, wrapper.data('qty'), function(){
            reloadShoppingBag(function(){
                if($("#item-removed-modal").length) {
                    $.modal({
                        open: "item-removed-modal",
                        triggerOpen: true
                    });
                }
            }, removedItemIndex);
        });
    }else{
        wrapper.data('qty', parseInt(newQty));
        const sectionURL = wrapper.data('sectionurl');
        const name = wrapper.data('name');
        const brand = wrapper.data('brand');
        const categoryName = wrapper.data('category');
        const price = wrapper.data('price');
        const currencyCode = wrapper.data('currency');
        const department = wrapper.data('department');
        const cat1 = wrapper.data('cat1');
        updateBag(code, size ,newQty, sectionURL, name, brand, categoryName, price, currencyCode, oldQty, department, cat1);
    }
    logEngagement(
        window.location.href,
        ENGAGEMENT_MODULE,
        'edit_quantity',
        { code: code }
    );
}

function loadSizeMenu(code, $sizeContent, successCallback) {
  if ($sizeContent.html().indexOf('fixed-overlay__item') >= 0) {
    //Remove the ability to scroll main content while overlay is present
    $('body').css({'overflow-y': 'hidden'});
    $sizeContent.addClass("fixed-overlay__scroll--active");
    return;
  }
    $.ajax({
        type: "GET",
        url: "/fw/ajax/GetProductSizeMenu.jsp?code=" + code,
        success: successCallback
    });
}

function addToBagFromItemListContainer(code, size, btn, module_name, action_name, success_notification_modal_id) {

    if(window.hasReachedBagLimit(code, size, 1, true)){
        return;
    }
    const bagCount = parseInt($("#shopping_bag_count").text(), 10);
    addToBag(code, size, btn,function () {
        logEngagement(window.location.href, module_name, action_name);
        if (bagCount === 0) {
            location.reload();  // init PayPal button when adding to empty cart
        } else {
            $.modal({
                open: success_notification_modal_id,
                triggerOpen: true
            });
        }
    });
}


function addToBagFromWishList(code, size, btn) {

    if(window.hasReachedBagLimit(code, size, 1, true)){
        return;
    }
    const bagCount = parseInt($("#shopping_bag_count").text(), 10);
    addToBag(code, size, btn,function () {
        logEngagement(window.location.href, "wish_list", "move_to_bag");
        if (bagCount === 0) {
            location.reload();  // init PayPal button when adding to empty cart
        } else {
            $.modal({
                open: "wishlist-added-modal",
                triggerOpen: true
            });
        }
    });
}

function addToBag(code, size, btn, successCallback, serial){
    var name = btn.data('name');
    var brand = btn.data('brand');
    var retailPrice = btn.data('price');
    var imageUrl = btn.data('imageUrl');
    var pdpUrl = btn.data('pdpUrl');
    var fullPdpUrl = btn.data('fullPdpUrl');
    var currency = btn.data('currency');
    var color = btn.data('color');
    var categoryName = btn.data('category');
    var qty = btn.data('qty') || 1;
    var department = btn.data('department');
    var cat1 = btn.data('cat1');

    $.post('/r/ajax/AddItemToBag.jsp',
        $.param({
            colorSelect: code,
            sizeSelect: size,
            serialNumber: serial,
            count: qty,
            dateAdded: btn.data('dateAdded')
        }),
        function() {
            if(typeof callInsertCordialBagEvent === 'function'){
                callInsertCordialBagEvent('add', code, size, name, brand, retailPrice, imageUrl, pdpUrl, categoryName, 1, department, cat1);
            }
            if (typeof window.insertPageTrackForMobile === 'function'){
                window.insertPageTrackForMobile(true, code);
            }

            if(typeof brazeAddToCart === 'function') {
                brazeAddToCart('add',
                    code, name, size, imageUrl, fullPdpUrl, retailPrice, currency, department, color, brand, categoryName, cat1);
            }

            reloadShoppingBag(successCallback);
        }
    );

}

function removeFromBag(code,size, qty, callback, serial, movedToWishList, $cartItem)
{
    var data = $.param({
        code : code,
        size : size,
        serial: serial,
        movedToWishList : movedToWishList
    });

    $.post("/r/ajax/RemoveFromBag.jsp", data, function(){
        if(typeof callInsertCordialBagEvent === 'function'){
            callInsertCordialBagEvent('remove', code, size, null, null, null, null, null, null, qty);
        }
        if (typeof window.gaAddToCartActionWithAjax === 'function'){
            window.gaAddToCartActionWithAjax('remove', code, size, qty);
        }
        if (typeof window.insertTaboolaAddToCart === 'function'){
            window.insertTaboolaAddToCart("remove", code);
        }

        if (typeof brazeAddToCart === 'function') {
            brazeAddToCart('remove',
                code,
                $cartItem.data('name'),
                size,
                $cartItem.data('imageurl'),
                $cartItem.data('pdpurl'),
                $cartItem.data('price'),
                $cartItem.data('currency'),
                $cartItem.data('department'),
                $cartItem.data('color'),
                $cartItem.data('brand'),
                $cartItem.data('category'),
                $cartItem.data('cat1'));
        }

        if(typeof callback === 'function'){
            callback();
        }


    });

}
function updateBag(productcode,size,totalval, sectionURL, name, brand, categoryName, price, currencyCode, previousTotal, department, cat1) {
    var total = totalval;

    var qtyToAdd = parseInt(total) - previousTotal;
    if(window.hasReachedBagLimit(productcode, size, qtyToAdd)){
        window.rcProps.ReCAPTCHACallBack = function(){
            window.rcProps.showReCAPTCHA = false;
            window.rcProps.maxLimit = 50;
            updateBag(productcode,size,totalval, sectionURL, name, brand, categoryName, price, currencyCode, previousTotal);
        };
        window.rcProps.ReCAPTCHARestore = function(){
            $("select#"+totalval).val(previousTotal);
        };
        return ;
    }

    $.ajax({
        type: "POST",
        url: "/r/ajax/EditCartItem.jsp",
        data: {
            code: productcode,
            size: size,
            qty: totalval
        },
        success: function() {
            reloadShoppingBag(function(){
                $.modal({
                    open: "item-qty-update-modal",
                    triggerOpen: true
                });
            });

            var qtyChange = total - previousTotal;

            if(qtyChange > 0) {
                if(typeof callInsertCordialBagEvent === 'function'){
                    callInsertCordialBagEvent('add', productcode, size, name, brand, price, null, null, categoryName, qtyChange, department, cat1);
                }

                if (typeof window.gaAddToCartActionWithAjax === 'function'){
                    window.gaAddToCartActionWithAjax('add',productcode,size,qtyChange);
                }

                if (typeof window.insertTaboolaAddToCart === 'function'){
                    window.insertTaboolaAddToCart("add", productcode);
                }
            } else if(qtyChange < 0) {
                if(typeof callInsertCordialBagEvent === 'function'){
                    callInsertCordialBagEvent('remove', productcode, size, name, brand, price, null, null, categoryName, Math.abs(qtyChange), department, cat1);
                }

                if (typeof gaAddToCartActionWithAjax === 'function'){
                    window.gaAddToCartActionWithAjax('remove',productcode,size,Math.abs(qtyChange));
                }
                if (typeof addToCartYahoo === 'function'){
                    window.addToCartYahoo(productcode);
                }

                if (typeof window.insertTaboolaAddToCart === 'function'){
                    window.insertTaboolaAddToCart("remove", productcode);
                }
            }

            if(typeof window.insertPageTrackForMobile === 'function'){
                window.insertPageTrackForMobile(true, productcode);
            }
            updateBagCount();
        }
    });

}

function updateBagCount(){
    $.ajax({
        type: "POST",
        url: "AjaxUserShoppingBag.jsp",
        success: function(response) {
            var responseObj = eval('(' + response + ')');
            $("#shopping_bag_count").html(responseObj);
        }
    });
}

function callInsertCordialBagEvent(action, code, size, name, brand, retailPrice, imageUrl, pdpUrl, categoryName, qty, department, cat1) {
    var cartItems = new Array();
    var cartItem = {};
    cartItem.productCode = code;
    cartItem.productCategory = categoryName;
    cartItem.productName = name;
    cartItem.imageUrl = [imageUrl];
    cartItem.description = '';
    cartItem.price = retailPrice;
    cartItem.url = pdpUrl;
    cartItem.brandName = brand;
    cartItem.size = size;
    cartItem.department = department;
    cartItem.cat1 = cat1;
    if(typeof(qty) == 'undefined' || qty == null) {
        cartItem.qty = 1;
    } else {
        cartItem.qty = qty;
    }
    cartItems.push(cartItem);

    if(action == 'add') {
        if(typeof window.insertCordialAddToCart === 'function'){
            window.insertCordialAddToCart(cartItems, null);
        }

    }
    if(action == 'remove') {
        if(typeof window.insertCordialRemoveFromCart === 'function'){
            window.insertCordialRemoveFromCart(name, code, retailPrice, brand, categoryName, qty);
        }
    }
}


function showBagSyncNotifications(){
    if(window.rcProps.shoppingBag.isGuest){
        return;
    }

    var data = $.param({
        notificationsHandled: true,
        mobile: true,
        fw: true
    });
    $.ajax({
        type: 'POST',
        url: '/r/ajax/GetBagSyncNotifications.jsp',
        data: data,
        success: function(rtn){
            var obj = JSON ? JSON.parse(rtn) : $.parseJSON(rtn);
            if (obj.success){
                var type = obj.msg4;
                var notificationModalId = '';
                if('new_customer' === type){
                    notificationModalId = 'save-shopping-bag-1';
                }else if('no_previous_items' === type){
                    notificationModalId = 'save-shopping-bag-2';
                }else if('return_customer' === type){
                    notificationModalId = 'save-shopping-bag-3';
                }else if('return_customer_checkout' === type){
                    notificationModalId = 'save-shopping-bag-4';
                }

                if(notificationModalId != ''){
                    $.modal({
                        open: notificationModalId,
                        triggerOpen: true
                    });
                }
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/shoppingbag/index.js